import React, { useState, useEffect } from "react";

const CountdownTimer = () => {
  const targetTime = new Date(); // set your target time here
  targetTime.setUTCHours(9, 0, 0, 0); // set the target time to 9 am GMT

  const closeTime = new Date(); // set your target time here
  closeTime.setUTCHours(20, 0, 0, 0); // set the target time to 9 am GMT

  const calculateTimeLeft = () => {
    const now = new Date().getTime();
    const difference = targetTime - now;

    if (difference > 0) {
      // setMarketOpen(false);
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      return { hours, minutes, seconds };
    } else {
      // Target time has passed
      // setMarketOpen(true);
      return { hours: 0, minutes: 0, seconds: 0 };
    }
  };

  const checkOpen = () => {
    const now = new Date().getTime();
    const difference = targetTime - now;
    if (difference > 0) {
      return false;
    } else {
      return true;
    }
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [marketOpen, setMarketOpen] = useState(checkOpen());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
      setMarketOpen(checkOpen());
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft]);

  return (
    <div style={{ color: "white" }}>
      {!marketOpen ? (
        <div>
          <p>السوق مغلق</p>
          <p>
            {`${timeLeft.hours}h ${timeLeft.minutes}m ${timeLeft.seconds}s`}
          </p>
        </div>
      ) : closeTime - new Date().getTime() < 0 ? (
        <div>
          <p>السوق مغلق</p>
          <p>حتى الصباح</p>
        </div>
      ) : (
        <p> السوق مفتوح </p>
      )}
    </div>
  );
};

export default CountdownTimer;
